import { render, staticRenderFns } from "./submit-button.vue?vue&type=template&id=2af03e3c"
import script from "./submit-button.vue?vue&type=script&lang=js"
export * from "./submit-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2af03e3c')) {
      api.createRecord('2af03e3c', component.options)
    } else {
      api.reload('2af03e3c', component.options)
    }
    module.hot.accept("./submit-button.vue?vue&type=template&id=2af03e3c", function () {
      api.rerender('2af03e3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/submit-button.vue"
export default component.exports